export default __webpack_public_path__ + "static/media/tux_banner_50.cefe5b13.png";